import * as service from '../../services'

export const generalItems = async () => {
  const familyAll = await service.getFamilyAll()
  const specieAll = await service.getSpecieAll()
  const siteNameAll = await service.getSiteNameAll()
  const pseudonymAll = await service.getPseudonymAll()
  const siteSectionAll = await service.getSiteSectionAll()
  const siteSiteAcronymAll = await service.getSiteAcronymAll()
  const {
    options: zoneTypesAll,
    defaultId: defaultZoneId,
    fullData: zoneTypesFullData,
  } = await service.getZoneTypesAll()
  const {
    options: siteTypesAll,
    defaultId: defaultSiteId,
    fullData: siteTypesFullData,
  } = await service.getSiteTypesAll()

  const items = [
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'family_',
      initvalue: '',
      label: 'Familia',
      options: familyAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'specie_',
      initvalue: '',
      label: 'Especie',
      options: specieAll,
    },
    {
      x: 12,
      s: 12,
      m: 6,
      name: `pseudonym_`,
      data: [],
      options: pseudonymAll,
      label: 'Nombre común',
      variant: 'standard',
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'typeSite_',
      initvalue: defaultZoneId ?? '',
      label: 'Eje verde',
      options: zoneTypesAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'sitePlace_',
      initvalue: defaultSiteId ?? '',
      label: 'Emplazamiento',
      options: siteTypesAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'site_',
      initvalue: '',
      label: 'Sitio',
      multiline: true,
      align: 'center',
      options: siteNameAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'siteAcronym_',
      initvalue: '',
      label: 'Acrónimo de Ubicación',
      multiline: true,
      align: 'center',
      options: siteSiteAcronymAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'section_',
      initvalue: '',
      label: 'Sección',
      multiline: true,
      align: 'center',
      options: siteSectionAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'alive_',
      initvalue: 1,
      label: 'Estado actual',
      options: { 0: 'Muerto', 1: 'Vivo' },
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'treeVerified_',
      initvalue: 0,
      label: 'Estado de registro',
      options: { 0: 'No verificado', 1: 'Verificado' },
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'recorded_',
      initvalue: '',
      label: 'Nombre del colector',
      multiline: true,
      align: 'center',
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'commit_',
      initvalue: '',
      label: 'Notas adicionales sobre árbol...',
      multiline: true,
      align: 'start',
    },
  ]

  return {
    items,
    zoneTypesFullData: zoneTypesFullData || {},
    allSiteTypes: siteTypesAll || {},
    siteTypesFullData: siteTypesFullData || {},
  }
}
